import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { IAnimal } from './animal.model';

@Injectable()
export class AnimalService {
  constructor(private apiService: ApiService) {}

  GetAll(): Promise<Array<IAnimal>> {
    return this.apiService.get('v1/animals');
  }
}
